export const environment = {
  production: true,
  VERSION_SW: '103',
  SERVER_API_URL: 'https://blinee.fr/',
  googleAnalyticsTrackingCode: 'G-F68WN7E13V',
};
